import { render, staticRenderFns } from "./OptionsInfo.vue?vue&type=template&id=ff4382b0&"
import script from "./OptionsInfo.vue?vue&type=script&lang=js&"
export * from "./OptionsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports